import { Button } from "nq-component";
import InputFactory from "../../../../../components/InputFactory";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import SchedulePresenter from "./SchedulePresenter";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import BaseFormPage from "../../../../../base/BaseFormPage";
import Divider from "../../../../../components/common/Divider";

export default class ScheduleForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new SchedulePresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      upsertUseCase(),
    );
    this.state = {
      selectedOption: "",
      selectedDay: "",
      timeIn: "",
      timeOut: "",
      sequence: "",
      earliestTimeOut: "",
      lateTimeIn: "",
    };
  }

  getCollectionName() {
    return "schedule_template";
  }

  getSelectedDay() {
    return this.state.selectedDay;
  }

  render() {
    const { object, sequence, selectedOption } = this.state;
    const options =
      sequence === "9/12/12.5/13 HOURS"
        ? [
            "Regular",
            "Graveyard",
            "Regular 3days Working, 3days off",
            "Graveyard 3days Working, 3days off",
            "Regular 4days Working, 2days off",
            "Graveyard 4days Working, 2days off",
          ]
        : [
            "Daily (M-F)",
            "Alternate (MWF)",
            "Alternate (TTHS)",
            "Weekend (Sat-Sun)",
            "Specific Day",
            "4days Working, 2days off",
          ];

    const sequences = ["10.5 HOURS", "9/12/12.5/13 HOURS", "24 HOURS"];

    const selectedDay = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    const onchangeField = (field, value) => {
      if (field === "selectedOption") {
        this.setState({ [field]: value, selectedDay: "" });
      }
      if (field === "sequence") {
        this.setState({
          [field]: value,
          selectedOption: "",
          timeIn: "",
          timeOut: "",
        });
      }
      this.setState({ [field]: value });
    };

    return (
      <>
        <div
          className="w-100 d-flex row"
          style={{
            height: "50px",
            padding: 0,
            alignItems: "center",
            // border: "3px solid",
            margin: "20px 0",
            justifyContent: "center",
          }}
        >
          <Divider title="Schedule" style={{ padding: 0 }} />
        </div>

        {/* schedule  */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.presenter.handleAddSchedule(object);
          }}
        >
          <div className="row p-0 mt-0 d-flex">
            <div className="col-lg-11">
              <div className="row">
                <div className="col-lg-3 p-1">
                  <label>
                    Sequence
                    <span className="text-danger">*</span>
                  </label>
                  <SearchSelect
                    disabled={this.props.disabled}
                    value={sequence}
                    onChange={(val) => onchangeField("sequence", val)}
                    required={true}
                    onClickClear={() => onchangeField("sequence", "")}
                    options={sequences.map((option) => ({
                      label: option,
                      value: option,
                    }))}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-11 align-items-end">
              <div className="row">
                <div className="col-lg-3 p-1">
                  <label>
                    Option
                    <span className="text-danger">*</span>
                  </label>
                  <SearchSelect
                    disabled={this.props.disabled || sequence === "24 HOURS"}
                    value={selectedOption}
                    onChange={(val) => onchangeField("selectedOption", val)}
                    required={true}
                    onClickClear={() => onchangeField("selectedOption", "")}
                    options={options.map((option) => ({
                      label: option,
                      value: option,
                    }))}
                  />
                </div>
                <div className="col-lg-3 p-1">
                  <label>
                    {sequence !== "10.5 HOURS" ? "Select Day" : "Specific Day"}
                    <span className="text-danger">*</span>
                  </label>
                  <SearchSelect
                    disabled={
                      (selectedOption !== "Specific Day" &&
                        sequence === "10.5 HOURS") ||
                      this.props.disabled ||
                      selectedOption === "4days Working, 2days off" ||
                      selectedOption === "Regular 3days Working, 3days off" ||
                      selectedOption === "Graveyard 3days Working, 3days off" ||
                      selectedOption === "Graveyard 4days Working, 2days off" ||
                      selectedOption === "Regular 4days Working, 2days off"
                    }
                    value={
                      selectedOption === "Specific Day" ||
                      sequence !== "10.5 HOURS" ||
                      selectedOption === "4days Working, 2days off"
                        ? this.state.selectedDay
                        : ""
                    }
                    required={true}
                    onClickClear={() => onchangeField("selectedDay", "")}
                    onChange={(val) => onchangeField("selectedDay", val)}
                    options={selectedDay.map((option) => ({
                      label: option,
                      value: option,
                    }))}
                  />
                </div>
                <div className="col-lg-3 p-1">
                  <label>
                    Time-In
                    <span className="text-danger">*</span>
                  </label>
                  <InputFactory
                    type="String"
                    _type="_time"
                    disableAM={
                      [
                        "Graveyard",
                        "Graveyard 3days Working, 3days off",
                        "Graveyard 4days Working, 2days off",
                      ].includes(selectedOption) && true
                    }
                    // disablePM={
                    //   [
                    //     // "Regular",
                    //     "Regular 3days Working, 3days off",
                    //     "Regular 4days Working, 2days off",
                    //   ].includes(selectedOption) && true
                    // }
                    disabled={this.props.disabled}
                    value={this.state.timeIn}
                    object={object}
                    onChange={(val) => onchangeField("timeIn", val)}
                    required={true}
                  />
                </div>
                <div className="col-lg-3 p-1">
                  <label>Time-Out</label>
                  <span className="text-danger">*</span>
                  <InputFactory
                    type="String"
                    _type="_time"
                    value={this.state.timeOut}
                    disablePM={
                      [
                        "Graveyard",
                        "Graveyard 3days Working, 3days off",
                        "Graveyard 4days Working, 2days off",
                      ].includes(selectedOption) && true
                    }
                    disableAM={
                      // sequence === "10.5 HOURS" ||
                      [
                        "Regular",
                        "Regular 3days Working, 3days off",
                        "Regular 4days Working, 2days off",
                      ].includes(selectedOption) && true
                    }
                    disabled={this.props.disabled}
                    object={object}
                    onChange={(val) => onchangeField("timeOut", val)}
                    required={true}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-1 d-flex align-items-center justify-content-end p-1">
              <Button
                type="submit"
                // onClick={() => this.presenter.handleAddSchedule(object)}
                disabled={this.props.disabled}
              >
                Add
              </Button>
            </div>

            <div className="col-lg-11">
              <div className="row">
                <div className="col-lg-3 p-1">
                  {(selectedOption === "4days Working, 2days off" ||
                    selectedOption === "Regular 3days Working, 3days off" ||
                    selectedOption === "Graveyard 3days Working, 3days off" ||
                    selectedOption === "Graveyard 4days Working, 2days off" ||
                    selectedOption === "Regular 4days Working, 2days off") && (
                    <>
                      <label>Date</label>
                      <span className="text-danger">*</span>
                      <InputFactory
                        type="String"
                        _type="Date"
                        value={this.state.startingDate}
                        object={object}
                        // min={new Date().toISOString().split("T")[0]}
                        onChange={(val) => onchangeField("startingDate", val)}
                        required={true}
                      />
                    </>
                  )}
                </div>
                <div className="col-lg-3 p-1"></div>

                <div className="col-lg-3 p-1">
                  <label>Late Time-In (Optional)</label>
                  <InputFactory
                    type="String"
                    _type="_time"
                    // disableAM={
                    //   [
                    //     "Graveyard",
                    //     "Graveyard 3days Working, 3days off",
                    //     "Graveyard 4days Working, 2days off",
                    //   ].includes(selectedOption) && true
                    // }
                    // disablePM={
                    //   [
                    //     // "Regular",
                    //     "Regular 3days Working, 3days off",
                    //     "Regular 4days Working, 2days off",
                    //   ].includes(selectedOption) && true
                    // }
                    disabled={this.props.disabled}
                    value={this.state.lateTimeIn}
                    object={object}
                    onChange={(val) => onchangeField("lateTimeIn", val)}
                  />
                </div>
                <div className="col-lg-3 p-1">
                  <label>Earliest Time-Out (Optional)</label>
                  <InputFactory
                    type="String"
                    _type="_time"
                    value={this.state.earliestTimeOut}
                    // disablePM={
                    //   [
                    //     "Graveyard",
                    //     "Graveyard 3days Working, 3days off",
                    //     "Graveyard 4days Working, 2days off",
                    //   ].includes(selectedOption) && true
                    // }
                    // disableAM={
                    //   [
                    //     "Regular",
                    //     // "Regular 3days Working, 3days off",
                    //     // "Regular 4days Working, 2days off",
                    //   ].includes(selectedOption) && true
                    // }
                    disabled={this.props.disabled}
                    object={object}
                    onChange={(val) => onchangeField("earliestTimeOut", val)}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
}
